import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import {
  IRuntimeConfig,
  defaultConfigMapValue,
} from 'env/defaultConfigMapValue';

export { IRuntimeConfig } from 'env/defaultConfigMapValue';

@Injectable({ providedIn: 'root' })
export class RuntimeConfigService {
  config: IRuntimeConfig = { ...defaultConfigMapValue };

  constructor(private http: HttpClient) {}

  load(): Promise<IRuntimeConfig> {
    return lastValueFrom(
      this.http
        // cache-bust param ensures browser always fetches fresh value on every
        // app startup — prevents stale feature flags after a kubectl configmap patch
        .get<IRuntimeConfig>('assets/runtime-environments/configMap.json', {
          params: { v: Date.now().toString() },
        })
        .pipe(
          tap((c) => {
            // merge with defaultConfigMapValue so any key missing from the fetched file
            // falls back to defaultConfigMapValue rather than becoming undefined
            if (c) this.config = { ...defaultConfigMapValue, ...c };
          }),
          // fall back to defaults if the file is missing or the request fails
          catchError(() => of(defaultConfigMapValue))
        )
    );
  }
}

export const initRuntimeConfig = (svc: RuntimeConfigService) => () =>
  svc.load();
